<template>
    <div id="slide_box" class="slide1">
        <div id="slide_content" :style="{background: siteCodeInfo[0].BACK_COLOR}">
            <div class="slide_block" id="slide1" :class="getShowClass()">
                <div class="slide_animate_block">
                    <div class="bg" :style="{background: siteCodeInfo[0].BACK_COLOR}">
                        <div class="wrap01">
                            <p class="img01"><img :src="imgCar" alt=""></p>
                            <p class="message01">お申込みありがとうございました。</p>
                            <p class="message06" v-if="largeFlg && mediumSmallFlg">回収品目毎に配送業者が異なります。</p>
                            <p class="day_title">ご希望回収日時</p>
                            <p class="day_txt">
                                <span class="no">{{ specificDate.split('/')[1] }}</span>月
                                <span class="no">{{ specificDate.split('/')[2] }}</span>日
                                <span id="youbi">{{ specificDay }}</span>&nbsp;
                                <span class="time">{{ specificTime.CODE_NM }}</span>
                            </p>
                            <p class="message05" v-if="largeFlg">※大型家電については、回収前のお電話をもって回収日時の確定となります。</p>
                            <dl class="id_box">
                                <dt>お客様の申込ID</dt>
                                <dd>{{ itemsDataTax.apply_id }}</dd>
                            </dl>
                            <div id="price_box">
                                <div class="price_block" v-if="largeFlg">
                                    <p class="caution_txt_01">梱包不要</p>
                                    <p class="message02 sp">配送業者SGムービングが<br>回収にお伺いします。</p>
                                    <div class="item_box" v-if="mediumSmallFlg">
                                        <p class="item_txt"><span class="category">回収品目</span>
                                            <span v-for="largeItem in largeItems" :key="largeItem.code">
                                                <span v-if="largeItem.unit"><br>●{{ largeItem.name }}</span>
                                            </span>
                                        </p>
                                    </div>
                                    <p class="price_txt_01">見積り料金<span class="zei">（税込）</span></p>
                                    <p class="price_txt_02">
                                        <span class="price">{{ itemsDataTax.largeTotalFeeLowInc.toLocaleString() }}</span>
                                        円
                                    </p>
                                    <p class="caution_txt_02 caution_txt_nf">※大型家電については、お電話にて搬出に関する確認のお電話をもって回収日時の確定となります。<br>不在着信があった場合、折り返しのご連絡をお願いします。</p>
                                    <p class="caution_txt_02 caution_txt_nf">※回収時に現物を確認して料金が最終確定します。</p>
                                    <p class="caution_txt_02 caution_txt_nf">※料金はドライバーに現金でお支払いください。</p>
                                </div>

                                <div class="price_block" v-if="mediumSmallFlg">
                                    <p class="caution_txt_01">箱への梱包必要</p>
                                    <p class="message02 sp">佐川急便が回収にお伺いします。</p>
                                    <div class="item_box" v-if="largeFlg">
                                        <p class="item_txt">
                                            <span class="category">回収品目</span>
                                            <span v-if="siteCodeInfo[0].PRICING_METHOD == 2">
                                                <span v-for="medium_item in itemsDataTax.medium_items" :key="medium_item.item">
                                                    <br>●{{ medium_item.item_nm }}
                                                </span>
                                                <span v-for="small_item in itemsDataTax.small_items" :key="small_item.item">
                                                    <br>●その他小型家電
                                                </span>
                                            </span>
                                            <span v-else>
                                                <br>●中型・小型サイズの家電
                                            </span>
                                        </p>
                                    </div>
                                    <p v-if="siteCodeInfo[0].CONFIRM_CHARGES_DISPLAY_FLG == '1'" class="price_txt_01">お支払合計<span class="zei">（税込）</span></p>
                                    <p v-if="siteCodeInfo[0].CONFIRM_CHARGES_DISPLAY_FLG == '1'" class="price_txt_02">
                                        <span>{{ itemsDataTax.mediumSmallTotalFee.toLocaleString() }}</span>円
                                        <span class="hako">（{{ itemsDataTax.mediumSmallQuantity }}箱分）</span>
                                    </p>
                                    <p v-if="siteCodeInfo[0].CONFIRM_CHARGES_DISPLAY_FLG == '1'" class="caution_txt_02 caution_txt_nf">※料金はドライバーへ現金でお支払いください。</p>
                                </div>

                                <p class="message03">
                                    ●ご登録いただいたメールアドレスに申込み完了メールが届きます。<br>
                                    お申込み内容のご確認をお願いいたします。<br>
                                    <span v-if="msgDispFlg">---------------------------------------------------<br>
                                    <!-- 毎年12月にリネット様から年末年始の休みを聞いてメッセージ内の年末年始休みの期間を書き換える。
                                        将来的には年末年始休みをマスタで管理し、マスタの設定で制御する予定 -->
                                    【年末年始のご対応につきまして】<br>
                                    2023年12月30日(土)～2024年1月4日（木）のお問い合わせ対応は、お休み致します。<br>
                                    この間にお客様からお寄せいただいたメールによる各種問合せ・手続き等は、<br>
                                    2024年1月5日（金）以降順次対応致しますのでご了承下さい。<br>
                                    ---------------------------------------------------</span>
                                </p>
                                <p class="caution_txt_03">※リネットジャパンのドメイン「＠renet.jp」を指定して、受信許可の設定をお願いいたします。迷惑メールボックスに届く場合は、設定の解除をお願いいたします。</p>
                                <div v-if="erasePcFlg" class="print_application_form_box">
                                    <div class="top_msg_box">
                                        <p class="top_msg">「おまかせ安全データ消去サービス」の申込書をご用意ください</p>
                                    </div>
                                    <div class="print_msg_area">
                                        <p class="print_mid_msg">手書きで申込書をご用意ください。</p>
                                        <div class="imgBox">
                                            <img :src="img_sample" alt="">
                                        </div>
                                        <ul class="print_mid_msg_detail">
                                          <li>・申込書には、「申込ID」「お名前」「メーカー名（必須）」「型番（任意）」「台数」をご記入ください。</li>
                                          <li>・メモ用紙等あまり小さな紙ではなく、A4コピー用紙や、便箋等をご用意ください。</li>
                                          <li>・1台につき1枚、申込書をご用意ください。</li>
                                          <li>・消去をご希望されるパソコン本体へ、申込書をテープで留めてください。</li>
                                          <li>・申込書に記入漏れがある場合や、パソコン本体にテープ留めされていない場合は、データ消去のお申し込みをいただいてもデータ消去証明書の発行が出来ないことがございますのでご了承ください。</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CompleteDisp from '../../js/CompleteDisp'

export default {
    props: {
        siteCodeInfo: Array,
    },
    data() {
        return {
            specificDate: '',
            specificDay: '',
            specificTime: '',
            itemsDataTax: [],
            largeItems: [],
            largeFlg: false,
            mediumSmallFlg: false,
            imgCar: CompleteDisp.common.constant.IMAGE_CAR,
            msgDispFlg: false,
            erasePcFlg: false,
            erasePcNum: 0,
            img_sample: CompleteDisp.common.constant.IMAGE_SAMPLE_SP,
        }
    },
    created() {
        // 初期表示時
        CompleteDisp.identifyItem(this)
        this.erasePcNum = CompleteDisp.common.getStore(this, 'erasePcNum')
    },
    methods: {
    },
}

</script>
